
import { combineReducers } from "redux";
import { newUserData } from "./CreateUser";
import { forgotpasswordData,forgotUsernameData } from "./Forgotpassword";
import { loginData } from "./Login";
import { TOKENData } from "./Token";
import { reportData } from "./Report";
import { roleData } from "./Role";
import { commonData } from "./Common";
import { inputFormData } from "./ProcessScheduler";
import { aarolesData } from "./Aaroles";
import { aapermissionsData } from "./Aapermissions";
import { aarolespermissionData } from "./Aarolespermission";
import { AaapermissionData } from "./Aaapermission";
import { passwordhistoryData } from "./Passwordhistory";
import { commondetailsData } from "./Commondetails";
import { passwordresetData } from "./Passwordreset";
import { passwordpolicyData } from "./Passwordpolicy";
import { newpasswordresetData } from "./Newpasswordreset";
import { RCREPORTSData } from "./Rcreports";
import { COMMONCATEGORYData } from "./Commoncategory";
import { SESSIONData } from "./Session";
import { companyData,visacareCorporateData} from "./AddCorporate";
import { emailData} from "./AddEmail";

import { visaCareAttorneyData,visaCareFirmData ,visaCareCorporateData,visaCareLawFirmCaseData,lawfirmListData} from "./LawFirm";


import { attorneyData,caseFlowg28Data,g28PdfGenerationNewData } from "./AddAttorney";
import { visaCareCaseIdData,visaCareCaseData ,visaCareEmptyCaseData,visaCareEmployeeBiogData,
  visaCareH1BFormData,h1bFormPdfData,uploadFileCaseFlowData,uploadFileH1BFormsData,
 visaCareH1BCaseIdAllData,attorneyG28Data,G28PdfData, I907FormData,I907PdfData,visaCareEmployerListData,petitionApprovedData
,employementData,employementAllData,visaCareAttorneyHelpCaseData} from "./VisaCareCase";
import {i130BioGraphicsData,i130FormData,i130FormPdfData,i130AFormData,i130AFormPdfData,i131FormData,i131FormPdfData,
  i864FormData,i864FormPdfData,i485FormData,i485FormPdfData} from "./I130Case";

import { employeeData } from "./Manageuser";
import { COMMONTYPEData,AllCOMMONTYPEData } from "./Commontype";
import { pdfData } from "./testPdfViewer";

import { visaCareH4FormData,visaCareH4FormTrackingData,h4FormPdfSubmitData} from "./VisaCareH4Case";
import { stripeCustomerData ,frequencyData,subcriptionData,companyDiscountData} from "./StripePayment";
import{  upcomingeventData,GETupcomingeventData,UPDATEeventData} from"./UpEvent";
import { EADCaseData ,EADPetitionData,EADPetitionPdfData} from "./VisaCareEADCase";
import { allDocumentCaseData ,documentCaseData} from "./DocumentCase";
import { visaCareI140FormData,i140FormPdfData,eta9089ExtractData } from "./VisaCareI140Case";
import {visaCareLCAPAFData,visaCareLCAPAFDataList} from "./VisacareLCAPAFData";
const reducers = combineReducers({
  loginData,
  TOKENData,
  newUserData,
  reportData,
  roleData,
  commonData,
  inputFormData,
  aarolesData,
  aapermissionsData,
  aarolespermissionData,
  AaapermissionData,
  passwordresetData,
  passwordhistoryData,
  commondetailsData,
  newpasswordresetData,
  passwordpolicyData,
  RCREPORTSData,
  COMMONCATEGORYData,
  SESSIONData,
  companyData,emailData,visaCareH1BCaseIdAllData,
  visaCareAttorneyData,visaCareFirmData,visaCareCorporateData,visaCareLawFirmCaseData,
  attorneyData,attorneyG28Data,G28PdfData,I907FormData,I907PdfData,
  visaCareCaseIdData,visaCareCaseData,visaCareEmployeeBiogData,visaCareEmptyCaseData,
  visaCareH1BFormData,h1bFormPdfData,uploadFileCaseFlowData,uploadFileH1BFormsData,
  visaCareH4FormData,visaCareH4FormTrackingData,h4FormPdfSubmitData,visaCareEmployerListData,
  employeeData,
  COMMONTYPEData,AllCOMMONTYPEData,
  pdfData,
  stripeCustomerData,frequencyData,subcriptionData,companyDiscountData,
  forgotpasswordData,forgotUsernameData,
  lawfirmListData,
  visacareCorporateData,
  petitionApprovedData,
  upcomingeventData,GETupcomingeventData,UPDATEeventData,employementData,employementAllData,
  EADCaseData,EADPetitionData,EADPetitionPdfData,
  allDocumentCaseData ,documentCaseData,visaCareI140FormData,i140FormPdfData,eta9089ExtractData,
  visaCareAttorneyHelpCaseData,caseFlowg28Data,g28PdfGenerationNewData,
  i130BioGraphicsData,i130FormData,i130FormPdfData,i130AFormData,i130AFormPdfData,i131FormData,i131FormPdfData,
  i864FormData,i864FormPdfData,i485FormData,i485FormPdfData,visaCareLCAPAFData,visaCareLCAPAFDataList
});
export default reducers;
